import * as XLSX from "xlsx";
import { HEADERS, normalizeRows } from "./storyFormat";

export const EXAMPLE_ROWS = [
  {
    key: 1,
    optionText: "Take the lantern",
    leadsTo: 1,
    desc: "A small flame pushes back the dark. The forest feels a little less lonely.",
    requirements: "",
    blocker: "lantern",
    rewards: "lantern",
    removes: "",
  },
  {
    key: 1,
    optionText: "Follow the winding path",
    leadsTo: 2,
    desc: "Between the trees, a forgotten gate waits for you.",
    requirements: "",
    blocker: "",
    rewards: "",
    removes: "",
  },
  {
    key: 2,
    optionText: "Light the inscription",
    leadsTo: 0,
    desc: "In the lantern light, the gate reveals its secret. Your next adventure is just beginning. The end.",
    requirements: "lantern",
    blocker: "",
    rewards: "",
    removes: "",
  },
  {
    key: 2,
    optionText: "Return to the clearing",
    leadsTo: 1,
    desc: "You retrace your steps to the clearing.",
    requirements: "",
    blocker: "",
    rewards: "",
    removes: "",
  },
];
export async function importWorkbook(file) {
  if (!file || !/\.xlsx$/i.test(file.name))
    throw new Error("Choose an .xlsx workbook.");
  if (file.size > 5 * 1024 * 1024)
    throw new Error("The workbook must be smaller than 5 MB.");
  const workbook = XLSX.read(await file.arrayBuffer(), { type: "array" });
  const sheet = workbook.Sheets[workbook.SheetNames[0]];
  const [headers = []] = XLSX.utils.sheet_to_json(sheet, { header: 1 });
  if (!HEADERS.every((header) => headers.includes(header)))
    throw new Error(
      `The first sheet must include these columns: ${HEADERS.join(", ")}.`,
    );
  return normalizeRows(
    XLSX.utils.sheet_to_json(sheet, { defval: "", raw: true }),
  );
}
export function exportWorkbook(rows, name = "story") {
  const workbook = XLSX.utils.book_new();
  const sheet = XLSX.utils.json_to_sheet(
    rows.map((row) =>
      Object.fromEntries(HEADERS.map((field) => [field, row[field] ?? ""])),
    ),
    { header: HEADERS },
  );
  sheet["!cols"] = HEADERS.map((field) => ({
    wch: field === "desc" ? 70 : field === "optionText" ? 35 : 20,
  }));
  XLSX.utils.book_append_sheet(workbook, sheet, "Story");
  XLSX.utils.book_append_sheet(
    workbook,
    XLSX.utils.aoa_to_sheet([
      ["Pick Your End — story workbook"],
      [
        "Each row is a choice. Choices with the same key appear in the same scene. The story starts at key 1.",
      ],
      ["key", "Positive whole number identifying a scene."],
      ["optionText", "Button text shown to readers."],
      ["leadsTo", "Scene key to show next. Use 0 to end the story."],
      ["desc", "Narrative shown after this choice is selected."],
      [
        "requirements",
        "Show if the reader has ANY listed tag (legacy behavior). Separate tags with | or commas.",
      ],
      [
        "blocker",
        "Hide if the reader has ANY listed tag. Separate tags with | or commas.",
      ],
      [
        "rewards",
        "Grant tags. Separate tags with | or commas. The special tag restart clears all inventory.",
      ],
      ["removes", "Remove listed tags. Separate tags with | or commas."],
      [
        "Import replaces the choices in the editor. Save changes to overwrite the published story.",
      ],
    ]),
    "Instructions",
  );
  XLSX.writeFile(
    workbook,
    `${name.replace(/[^a-z0-9_-]+/gi, "_").slice(0, 80) || "story"}.xlsx`,
  );
}
